import clsx from "clsx";

const InputRadio = ({ label, id, name, register, value, rules, className }) => (
  <div className="flex items-center space-x-2.5">
    <input
      type="radio"
      {...register(name, rules)}
      id={id}
      value={value}
      className={clsx(
        "flex-shrink-0 w-5 h-5 bg-white checked:bg-blue rounded-full checked:border-2 checked:border-white appearance-none cursor-pointer hover:outline-blue-900",
        className
      )}
    />
    <label htmlFor={id}>{label}</label>
  </div>
);

export default InputRadio;
